<template>
  <div class="usc_sort">
    <span class="usc_sort_ttl">Currency:</span>
    <select class="cur-sel"
        @change="selectCurrency">
        <option 
            v-for="(currency,index) in currencies"
            :value="JSON.stringify(currency)"
            :key="index"
            :selected="selectedCurrency.name == currency.name"
        >{{currency.name}}</option>
    </select>
</div>
</template>

<script>
import { mapGetters,mapMutations } from "vuex";
export default {
    computed:{
        ...mapGetters({
            currencies:'shippingRates/currencies',
            selectedCurrency:'shippingRates/currency'
        })
    },

    methods:{
        ...mapMutations({
            _selectCurrency:'shippingRates/SET_CURRENCY'
        }),
        selectCurrency(e){  
            this._selectCurrency(JSON.parse(e.target.value))
        }
    }
}
</script>

<style scoped>
.cur-sel{
    padding-left:5px;
}
.usc_sort_ttl{
    font-size: 17px;
}
</style>


// WEBPACK FOOTER //
// resources/js/components/footer/CurrencySelector.vue